import React from "react";
import MasterTable from "../BaseMaster/MasterTable";

function QualityTable() {
  return (
    <>
      <MasterTable endpoint="/quality" name="Qualities" modalName="Quality" />
    </>
  );
}

export default QualityTable;
